import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

// Styles
import "./index.scss";

toast.configure({
  position: toast.POSITION.TOP_CENTER,
  autoClose: 8000,
});

export default {
  success(msg, options = {}) {
    return toast.success(msg, {
      ...options,
    });
  },
  error(msg, options = {}) {
    return toast.error(msg, {
      ...options,
    });
  },
  warning(msg, options = {}) {
    return toast.warning(msg, {
      ...options,
    });
  },
};
